import React from 'react';

/**
 * Modern Date Filter component
 * Props:
 *   preset: '7d' | '30d' | 'thisMonth' | 'all' | 'custom'
 *   onChange: (presetKey, { from, to }) => void
 *   from: string (YYYY-MM-DD)
 *   to: string (YYYY-MM-DD)
 */
const PRESETS = [
    { key: '7d', label: 'Last 7 Days' },
    { key: '30d', label: 'Last 30 Days' },
    { key: 'thisMonth', label: 'This Month' },
    { key: 'all', label: 'All Time' },
    { key: 'custom', label: 'Custom Range' },
];

const DateFilter = ({ preset = '30d', onChange, from = '', to = '' }) => {
    const handlePreset = (key) => {
        if (key !== 'custom') {
            onChange(key, {});
        } else {
            onChange('custom', { from, to });
        }
    };

    const handleCustomChange = (field, val) => {
        const updated = { from, to, [field]: val };
        onChange('custom', updated);
    };

    return (
        <div className="flex flex-wrap items-center gap-2">
            <div className="flex items-center gap-1 bg-stone-100/90 rounded-xl p-1 border border-stone-200/50">
                {PRESETS.map((p) => {
                    const active = preset === p.key;
                    return (
                        <button
                            key={p.key}
                            onClick={() => handlePreset(p.key)}
                            className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-all duration-150 ${
                                active
                                    ? 'bg-white text-stone-900 shadow-xs border border-stone-200/50'
                                    : 'text-stone-500 hover:text-stone-800'
                            }`}
                        >
                            {p.label}
                        </button>
                    );
                })}
            </div>

            {preset === 'custom' && (
                <div className="flex items-center gap-2 bg-white rounded-xl border border-stone-200 p-1.5 shadow-xs">
                    <input
                        type="date"
                        value={from}
                        onChange={(e) => handleCustomChange('from', e.target.value)}
                        className="text-xs font-medium text-stone-700 bg-transparent px-2 py-1 focus:outline-none"
                    />
                    <span className="text-xs text-stone-400 font-medium">to</span>
                    <input
                        type="date"
                        value={to}
                        onChange={(e) => handleCustomChange('to', e.target.value)}
                        className="text-xs font-medium text-stone-700 bg-transparent px-2 py-1 focus:outline-none"
                    />
                </div>
            )}
        </div>
    );
};

export default DateFilter;
